import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { SvgIconProps } from '@mui/material/SvgIcon';
import React from 'react';

const ResumeIcon = (props: SvgIconProps) => <PlayArrowIcon {...props} />;
export default ResumeIcon;
